<template>



 <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">
                <div class="card card-widget widget-user">
                <div class="widget-user-header text-white"
                                style="background: url('/assets/images/pexels-pixabay-Snow-Mountain2000fshead.png')  center;">
                                <h3 class="widget-user-username text-left">Acting on the Plan.</h3>
                                <h2 class="widget-user-desc text-right">For Version 2.0 of You.</h2>
                                <h3 class="widget-user-username text-right">The power of Consistent Action.</h3>
                            </div>
                            <div class="widget-user-image">
                                <img class="img-circle" src="/assets/images/artist128x128.png" alt="User Avatar">
                            </div>
                </div>
            </div>
        </div>
                    <div class="card p-2 m-6 bg-default">
                            <div class="row">
                                <div class="col-md-6">
                                    <h5>Select your Life-Area to See how you're doing:</h5>
                        <p><strong>Instructions:</strong> Tracks how often you visit your FutureSelf Vision (Helps you stay consistent)
                                and how well you are performing under each of your Life-Areas.</p>
                                </div>
                                <div class="col-md-3">
                                    <select class="p-2" style="margin:.5em;"  @change="displayMainReport($event.target.value)" v-model="sel_lifearea" >
                                        <option value="" :key="-1">Select a Life-Area</option>
                                        <!-- <option v-for="fsdets in myFSDetails" :key="fsdets.id" :value="fsdets.life_area" v-html="fsdets.life_area"></option> -->
                                        <option v-for="templ in myFSDetails" :key="templ.life_area" :value="templ.life_area" v-html="templ.life_area"></option>
                                    </select>
                                    <br/>
                                    <small>(The above are your remaining/un-addressed Life-Areas).</small>
                                </div>
                                <div class="col-md-2">
                                    <table class="table table-sm table-light table-striped small">
                                        <thead>
                                            <tr><td>Back to Dash</td><td>View my<br/>Performance</td>
                                                <!-- <td>Track my<br/>Performance</td> -->
                                            </tr></thead>
                                        <tbody>
                                        <tr>
                                            <td>
                                                <button class="btn btn-sm fai-blue bg-light"  title="Back to Dash"  @click="exitToDash">
                                                    <i class="fa fa-arrow-left fai-green p-2"></i>
                                                </button>
                                            </td>
                                            <td>
                                                <button class="btn btn-sm fai-blue bg-light" title="View My Performance"  @click="displayCharts()">
                                                    <i class="fas fa-eye fai-blue  p-2"></i>
                                                </button>
                                            </td>
                                            <!-- <td><button class="btn btn-sm fai-blue bg-light" title="Grade my Performance"  :disabled="grading" @click="gradeMyPerformance"> <i class="fas fa-list fai-orange p-2" ></i></button></td> -->
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                    </div>

                    <div class="list-group-item">
                        <div class="row">
                            <!-- <div v-for="aDet in myFSDetails"  :key="aDet.life_area" class="col-auto col-md-4"> -->
                                <div class="content-box-gray card" >
                                    <div class="title text-center d-flex">
                                        <h5 >Last Quarter Self-Evaluated  Effort</h5>
                                    </div>
                                    <!-- <div class="content"> -->
                                        <div class="card" style="padding:.5em;">
                                        <canvas id="chart1"></canvas>
                                        </div>
                                    <!-- </div> -->
                                <!-- </div> -->
                            </div>
                        </div>
                    </div>


        <div class="row mt-2">
            <div class="col-lg-8 col-8 mx-auto">

                <div class="row">
                    <!-- <div class=" col-lg-6 col-6 mx-auto" style="margin:.5em;" >
                        <div class="card" style="padding:.5em;">
                            <div class="small-box bg-warning text-center" ><h4 >Last Quarter Self-Evaluated  Effort</h4></div>
                            <canvas id="chart1"></canvas>
                        </div>
                    </div> -->
                    <div class=" col-lg-6 col-6 mx-auto" style="margin:.5em;" >
                        <div class="card" style="padding:.5em;">
                            <div class="small-box bg-warning text-center" ><h4> Visits</h4></div>
                            <canvas id="chart2"></canvas>
                        </div>
                    </div>
                    <div class=" col-lg-6 col-6 mx-auto" style="margin:.5em;" >
                        <div class="card" style="padding:.5em;">
                            <div class="small-box bg-warning text-center" ><h4 >Progressive Focus</h4></div>
                            <canvas id="chart2"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <canvas id="vision-chart"></canvas>
    </div>
</template>

<script>

import axios from 'axios';
import Chart from 'chart.js';
import { transparentize} from '../../chart/ChartUtils';
// import Swal from 'sweetalert2';
var _ = require('lodash');
import { v4 as uuidv4 } from 'uuid';
import und from 'underscore';
// import EventBus from '../../event-bus';


export default {
    components: {

     },
    name: "FutureMeTracker",
    data() {
        return {
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            userinfo:'',
            myFSDetails:[],
            myTracking:[],
            unprocLifeAreas:[],
            sel_lifearea:'',
            mylifeareas: '',
            lifeAreaPerformance:[],
            perfData:[],
            reports:[],

        }
    },

    props: {
        userdata:'',
        myfsdetails:[],
        tracking:[]
    },
    mounted() {
        this.userinfo = JSON.parse(this.userdata);
        this.myFSDetails = JSON.parse(this.myfsdetails);
        this.myTracking = JSON.parse(this.tracking);
        this.perfData = JSON.parse(this.myTracking.original.perfdata);
        this.unprocLifeAreas = this.todoLifeAreas();
        this.reports = ['overall', 'quarter', 'monthvists', 'lifeareaperformance' ];
        // this.createCanvasAndReport(this.reports);
        // this.createCharts();

        //this.setUserData();
        // document.getElementById('confHeadBtn').disabled = true;
        // this.componentName = new Array(this.MAX_HABIT_COMPONENTS);
        // this.componentPoints = new Array(this.MAX_HABIT_COMPONENTS);
        // this.deleteComponent = new Array(this.MAX_HABIT_COMPONENTS);
    },

    methods: {
        getMonthName(monthNum) {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
                ];
            // const d = new Date();
            // document.write("The current month is " + monthNames[d.getMonth()]);
            return monthNames[monthNum-1];
        },
         displayCharts(){
            var perfdata = this.getMonthPerfData();
            var labels =  this.genLabels(perfdata);
            var monthObjs = this.getMonthsPointsArrays(perfdata);
            console.log(monthObjs);
            this.createCompositeChart(labels, monthObjs);
            // monthObjs.foreach((monthObj) =>{



            // });
        },
        generateConfig(charttype, text ) {
            var config = {
                    type: charttype,
                    options: {
                    responsive: true,
                    plugins: {
                    legend: {
                        position: 'top',
                        },
                        title: {
                            display: true,
                            text: text
                        }
                    }
                }
            };
            return config;
        },
        getMonthPerfData() {
            return Object.assign([],this.perfData.month_perf);
        },
        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        },
        genLabels(data){
            var retvals = data.map((v, i, a) =>{
                 return v.lifearea;
            });
            retvals = retvals.filter(this.onlyUnique);
            // console.log(retvals);
            return retvals;
        },
        getMonthsPointsArrays(data) {
            var monthColors = ['pink', 'aqua', 'coral', 'green'];// need only 3 as 3 months in a quarter.
            //find number of months in the data:
           var monthvals =  data.map((v, i, a) =>{
                return v.month;
            });
            monthvals = monthvals.filter(this.onlyUnique);
            //  console.log(monthvals);

             var monthObjs = [];
            for(var z = 0; z<monthvals.length;z++) {
                var monthObj = {};
                monthObj.month =this.getMonthName(monthvals[z]);
                monthObj.color = monthColors[z];

                const pointsArr = [];
                for(let k = 0; k<data.length; k++){
                    if(data[k].month == monthvals[z]) pointsArr.push(data[k].points);
                }
                // console.error(pointsArr);
                monthObj.points = pointsArr;
                monthObjs.push(monthObj);
            }

            //  console.log(monthObjs);
            return monthObjs;
        },

        createCompositeChart(labels, monthObjs) {
            const datasets = monthObjs.map((monthObj)=>{
               return this.genFSDataSet('bar', monthObj.month, monthObj.points, monthObj.color);
            });
            // console.log(datasets);
            var chartInput = this.generateInput(labels, datasets);
            // console.error(chartInput);
            const ctx = document.getElementById('chart1');
            new Chart(ctx, chartInput); //hung new char on ctx
        },

   generateInput(labels, datasets,) {
            //generate Data from DB-supplied data:
            var input = {};
            var data= {
            labels:labels,
            datasets:datasets
            };
            // this.generateConfig('doughnut', 'bar', data, 'Peformance for '+lifeArea);
            var options = this.generateConfig('line', 'Overall Title');

            input.data= data;
            input.type= 'bar';//is the shape command bar, doughnut,line,  etc,
            input.options= options;
            // console.error(input);
            return input;
        },

    genFSDataSet(type, labelText, dataArray, bgColor = 'pink',   borderRadius = 100, borderWidth = 1, borderColor = "grey", ){
           return  {
                    label: labelText,
                    type: type,
                    data:dataArray,
                    borderColor: bgColor,
                    borderWidth: 2,
                    backgroundColor: transparentize(bgColor, 0.4),
                    borderRadius:borderRadius,
                    borderSkipped: false,
                };
        },


        createLACharts() {
            this.genLabels();
            //retrieve data for the user
            this.myFSDetails.map(la_fsDetails => {
                const ctx = document.getElementById('vision-chart-'+la_fsDetails.life_area);
                    console.log(la_fsDetails.life_area);

                // var chartInput = this.generateChartInput(life_area);
                // this.lifeAreaTrackerChart = new Chart(ctx, {
                //     type: planetChartData.type,
                //     data: planetChartData.data,
                //     options:  planetChartData.options,
                // });
                // var chartInput =  this.generateData(la_fsDetails.life_area);
                var chartInput =  this.generateFSPerfData(la_fsDetails.life_area);
                // console.log(chartInput);
                new Chart(ctx, chartInput); //hung new char on ctx

            });
        },

        createCanvasAndReport(reportsarray) {
            var data = '';
            reportsarray.map(report=> {
                if(report == 'overall') {
                    // data = perfData.month_visits;
                    data = this.perfData.month_perf;
                    this.genUniqueLabels(data);


                }



            });
        },

        genUniqueLabels(data){
            // var mvxday = Object.assign([], this.perfData.month_visits_by_day);
            var retvals = data.map(aday=>{
                if(!retVals.includes) return aday.lifeArea;
            });
            console.error(retvals);
            return retvals;
        },
        // getVisionChartID(life_area) {
        //     return 'vision-chart-' + life_area;
        // },
        getMonthVisitsByDay() {
            const xxxxxxx = this.perfData.month_visits_by_day;
            const mVxDayArr = {};
            xxxxxxx.filter(entry => {
                mVxDayArr[entry.date] = entry.vizcount;
                });
            console.log(mVxDayArr);
            this.monthVisitsByDayData = mVxDayArr;
            return mVxDayArr;
        },

        getMonthVisitsData() {
            var someArr = this.perfData.month_visits_by_day;
            console.log("getMonthVisitsData:");
            console.log(someArr);
        },
        createQtrChart(){
            // var data = Object.assign([],this.perfData.qtr_perf);
            var data = this.perfData.qtr_perf;
            console.log(data);
            var labels = data.map(obj=>{return obj.lifearea});
            var points = data.map(obj=>{return obj.points});
            console.error(labels);
            console.error(points);
        },

        getPerfData() {
             axios.get('/fself/' +this.userinfo.id + '/performance')
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.perfData = JSON.parse(res.data.perfdata);
                this.updateToast(this.message, 4000);
                console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                // this.success = false;

            })
            .finally(()=> {
                // location.reload();
            });
        },
        displayMainReport(event) {

        },







        exitToDash() {
            location.replace('/fself/dash');
        },
        getGUID() {
            var guid = uuidv4();
            console.log("GUID: " + guid);
            return guid;
        },
        // displayModal(val) {
        //     if(val != '') {
        //         const payload = {
        //         life_area: val,
        //         }
        //         EventBus.$emit('populateModal', payload);
        //     }
        // },
        todoLifeAreas() {
            var fsAreasWithout = [];
            var allLifeAreas = '';
            var myFSLifeDetailsAreas = this.myFSDetails.map((myd) => { return myd.life_area});

            this.mylifeareas = myFSLifeDetailsAreas;
            return fsAreasWithout;
        },


    }
}
</script>

<style scoped>

.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}
.fai-blue{
    color:#0707c0;
}
.fai-orange{
    color:#c05d07;
}
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#5fa3ca;
    font-size:.75em;
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}

</style>
